import React, { useCallback, useMemo } from "react";
import { useParams } from "react-router-dom";
import type { FMR1Fields } from "../../../../../api/fmr1";
import { BorrowerGroupName, YesNo } from "../../../../../api/fmr1";
import { useAppDispatch, useAppSelector } from "../../../../../app/store";
import { selectFMR1DraftFmrFields, updateFMR1DraftField } from "../../../logic/frm1Slice";
import { FmrSingleRowGridTable } from "../common/FmrSingleRowGridTable";

const PARTICULARS_COL_WIDTH = "253px";
const GOVT_BORROWER_COL1_WIDTH = "443px";
const GOVT_BORROWER_COL2_WIDTH = "250px";
const GOVT_BORROWER_COL3_WIDTH = "281px";

const YES_NO_OPTIONS = Object.values(YesNo).map((v) => ({ name: v, value: v }));
const BORROWER_GROUP_OPTIONS = Object.values(BorrowerGroupName).map((v) => ({ name: v, value: v }));

const BorrowerGroupTable: React.FC = () => {
  const { id: case_id } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();

  const draftFields = useAppSelector(selectFMR1DraftFmrFields);

  const emptyData = useMemo(() => ({}) as FMR1Fields, []);
  const mergedData = useMemo(() => {
    return { ...emptyData, ...(draftFields as any) } as FMR1Fields;
  }, [draftFields, emptyData]);

  const handleLocalChange = useCallback(
    (key: keyof FMR1Fields, value: any) => {
      if (!case_id) return;
      dispatch(updateFMR1DraftField({ key, value }));
    },
    [case_id, dispatch],
  );

  const belongs = mergedData.is_fraud_part_of_borrower_group ?? "";

  return (
    <FmrSingleRowGridTable
      title="Details on Borrower Group"
      particularsColWidth={PARTICULARS_COL_WIDTH}
      columns={[
        {
          headerName: "Whether the fraud belongs to any group? Yes/No",
          type: "select",
          options: YES_NO_OPTIONS as any,
          value: belongs,
          onChange: (v) => handleLocalChange("is_fraud_part_of_borrower_group", v),
          isEditable: true,
          colWidth: GOVT_BORROWER_COL1_WIDTH,
        },
        {
          headerName: "If yes, choose the name of the group",
          type: "select",
          options: BORROWER_GROUP_OPTIONS as any,
          value: mergedData.chosen_group_name ?? "",
          onChange: (v) => handleLocalChange("chosen_group_name", v),
          isEditable: true,
          colWidth: GOVT_BORROWER_COL2_WIDTH,
        },
        {
          headerName: "Others (Please specify)",
          type: "text",
          value: mergedData.borrower_group_info_others ?? "",
          onChange: (v) => handleLocalChange("borrower_group_info_others", v),
          isEditable: true,
          colWidth: GOVT_BORROWER_COL3_WIDTH,
        },
      ]}
    />
  );
};

BorrowerGroupTable.displayName = "BorrowerGroupTable";

export default BorrowerGroupTable;

